<template>
    <div id="cookie-settings" ref="cookiesOptions" class="modal fade" data-bs-backdrop="static" tabindex="-1">
        <div class="modal-dialog"> 
            <div class="modal-content modal-united">
                <div class="modal-header">
                    <h4 class="modal-title">{{$t('privacy.yourCookiePreferences')}}</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="abort"></button>
                </div>
                <div class="modal-body">
                    <i v-if="$parent.cookiePreferences == null">{{$t('privacy.canBeChangedInSettings')}}</i>
                    <div class="my-4" v-for="group in $parent.cookiePreferencesChoices">
                        <h5>{{group.title}}</h5>
                        <p v-html="sanitizeMarkup(group.description)"></p>
                        <template v-for="item in group.items">
                            <div v-if="!item.isRequired" class="line-options">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" :id="item.key" :checked="$parent.cookiePreferences != null && $parent.cookiePreferences.includes(item.key) || item.isRequired || item.isEnabled" :disabled="item.isRequired">
                                    <label class="form-check-label" :for="item.key">{{item.label}}</label>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="save">{{$t('privacy.saveSettings')}}</button>
                    <button type="button" class="btn btn-primary" @click="acceptAll">{{$t('privacy.acceptAll')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {sanitizeMarkup} from '../utils/markup';
import {Modal} from "bootstrap";

export default {
    methods: {
        sanitizeMarkup(html){
            return sanitizeMarkup(html);
        },
        save(){
            const optional = Array.from(this.$refs.cookiesOptions.querySelectorAll('input')).filter(i => i.checked).map(i => i.id);
            this.$parent.setCookiePreferences(optional);
        },
        acceptAll(){
            Array.from(this.$refs.cookiesOptions.querySelectorAll('input')).forEach(i => i.checked = true);
            Modal.getOrCreateInstance(this.$refs.cookiesOptions).hide();
            setTimeout(() => {
                this.$parent.acceptAllCookies();
            });
        },
        abort(){
            this.$parent.checkDisplayingCookieBanner();
        }
    }
}

</script>
